import React from 'react';
import { ReactComponent as House } from '../../../assets/images/svg/house.svg';
import { ReactComponent as Building } from '../../../assets/images/svg/building.svg';
import { ReactComponent as MapPinArea } from '../../../assets/images/svg/map-pin-area.svg';
import { ReactComponent as Bank } from '../../../assets/images/svg/bank.svg';

export const ADDRESS_TAG_TYPES = {
  HOME: 1,
  OFFICE: 2,
  OTHER: 3,
  BANK_ACCOUNT_STATEMENT: 4,
};

export default {
  [ADDRESS_TAG_TYPES.HOME]: 'Home',
  [ADDRESS_TAG_TYPES.OFFICE]: 'Office',
  [ADDRESS_TAG_TYPES.OTHER]: 'Other',
  [ADDRESS_TAG_TYPES.BANK_ACCOUNT_STATEMENT]: 'Bank',
};

export const ADDRESS_TAG_TYPES_ICONS = {
  [ADDRESS_TAG_TYPES.HOME]: <House />,
  [ADDRESS_TAG_TYPES.OFFICE]: <Building />,
  [ADDRESS_TAG_TYPES.OTHER]: <MapPinArea />,
  [ADDRESS_TAG_TYPES.BANK_ACCOUNT_STATEMENT]: <Bank />,
};
